import PortalSearchTable from "../../common/table/PortalSearchTable";
import { convertDate, OptionTableCell, TableButton } from "@duosoftbg/nacid-components";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import React, { useState } from "react";
import FeedbackDetailsDialog from "./FeedbackDetailsDialog";
import { useFormContext } from "react-hook-form";
import { NoMessage, YesMessage } from "../../../../utils/constants";

const headCells = [
  {
    id: "number",
    label: "l.table.head.number",
    sortable: false,
  },
  {
    id: "name",
    label: "l.table.head.person.name",
  },
  {
    id: "createdDate",
    label: "l.table.head.createdDate",
  },
  {
    id: "isRead",
    label: "l.table.head.isRead",
  },
  {
    id: "options",
    label: "",
    sortable: false,
  },
];

const FeedbackListTable = ({ records, total, onPageOrOrderChange, blockTable, group, fetch }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const { getValues } = useFormContext();

  const handleOpenDetails = (row) => {
    setSelectedRow(row);
    setOpenDialog(true);
  };

  return (
    <>
      <FeedbackDetailsDialog
        open={openDialog}
        setOpen={setOpenDialog}
        row={selectedRow}
        fetch={fetch}
      ></FeedbackDetailsDialog>
      <PortalSearchTable
        group={group}
        headCells={headCells}
        total={total}
        blockTable={blockTable}
        onPageOrOrderChange={onPageOrOrderChange}
      >
        <TableBody>
          {records.map((row, index) => {
            return (
              <TableRow hover key={row.id}>
                <TableCell>{index + 1 + getValues().page * getValues().pageSize}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{convertDate(row.createdDate)}</TableCell>
                <TableCell>{row.isRead ? <YesMessage /> : <NoMessage />}</TableCell>
                <OptionTableCell>
                  <TableButton type={"more"} onClick={() => handleOpenDetails(row)} />
                </OptionTableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </PortalSearchTable>
    </>
  );
};
export default FeedbackListTable;
